/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {WizardPageButtonsDirective} from './directives/page-buttons';
import {WizardPageHeaderActionsDirective} from './directives/page-header-actions';
import {WizardPageNavTitleDirective} from './directives/page-navtitle';
import {WizardPageTitleDirective} from './directives/page-title';
import {Wizard} from './wizard';
import {WizardButton} from './wizard-button';
// directives

import {WizardCustomTags} from './wizard-custom-tags';
import {WizardHeaderAction} from './wizard-header-action';
import {WizardPage} from './wizard-page';
import {WizardStepnav} from './wizard-stepnav';
import {WizardStepnavItem} from './wizard-stepnav-item';

export {Wizard} from './wizard';
export {WizardPage} from './wizard-page';
export {WizardStepnav} from './wizard-stepnav';
export {WizardStepnavItem} from './wizard-stepnav-item';
export {DEFAULT_BUTTON_TYPES,CUSTOM_BUTTON_TYPES,WizardButton} from './wizard-button';
export {WizardHeaderAction} from './wizard-header-action';

// directives
export {WizardCustomTags} from './wizard-custom-tags';
export {WizardPageTitleDirective} from './directives/page-title';
export {WizardPageNavTitleDirective} from './directives/page-navtitle';
export {WizardPageButtonsDirective} from './directives/page-buttons';
export {WizardPageHeaderActionsDirective} from './directives/page-header-actions';

export const /** @type {?} */ WIZARD_DIRECTIVES: any[] = [
    Wizard, WizardPage, WizardStepnav, WizardStepnavItem, WizardButton, WizardHeaderAction, WizardCustomTags,
    WizardPageTitleDirective, WizardPageNavTitleDirective, WizardPageButtonsDirective, WizardPageHeaderActionsDirective
];
